export default __webpack_public_path__ + "static/TX4-ES-a79c0638f1d4e141bda2da6c2fe6040f.svg";